import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

export const Item = ({
  item,
  index,
  markItem,
  deleteItem,
  list,
  listIndex,
  rollouts
}) => {
  return (
    <ListItem>
      <ListFlex>
        <Checkbox
          onClick={e => markItem(e, index, list && list.id, listIndex)}
          bgColor={item.done ? 'var(--theme-secondary-color)' : 'white'}
          width={deleteItem ? '70%' : '80%'}
        >
          {item.text}
        </Checkbox>
        {deleteItem && (
          <Button onClick={e => deleteItem(e, index)}>Delete item</Button>
        )}
        {rollouts &&
          rollouts.id === 'aislesFeature' &&
          rollouts.isActive === true && <div>aisle {item.aisle}</div>}
      </ListFlex>
    </ListItem>
  );
};

const ListItem = styled.li`
  list-style-type: none;

  &:not(:last-child) {
    margin-bottom: 20px;
  }
`;

const ListFlex = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Checkbox = styled.button`
  background: none;
  border: 0;
  width: ${props => props.width || '70%'};
  text-align: left;
  cursor: pointer;
  padding-left: 0;
  color: var(--theme-secondary-color);

  &:before {
    content: '';
    display: inline-block;
    border: 2px solid var(--theme-secondary-color);
    height: 30px;
    width: 30px;
    border-radius: 8px;
    vertical-align: middle;
    margin-right: 10px;
    background-color: ${props =>
      props.bgColor || 'var(--theme-secondary-color)'};
  }
`;

const Button = styled.button`
  background-color: #c8c8c8;
  color: var(--theme-primary-secondary);
  padding: 5px;
  font-size: 0.6rem;
  border-radius: 8px;
  border: 0;
  text-align: right;
`;
